import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

export default function ConditionsGenerales() {
  return (
    <main>
      <Navbar />

      <section className="pt-40 pb-24 bg-white">
        <div className="max-w-3xl mx-auto px-8 lg:px-6">
          <span className="font-sans text-xs tracking-widest uppercase text-brand-gris-light">
            Légal
          </span>
          <h1 className="font-serif font-light text-brand-noir text-5xl lg:text-6xl mt-5 mb-16 leading-tight">
            Conditions générales
          </h1>

          {/* Company info block */}
          <div className="border-l-4 border-brand-or bg-brand-beige px-8 py-6 mb-14 font-mono text-sm text-brand-gris leading-loose">
            <strong className="text-brand-noir not-italic font-sans font-medium tracking-wider">MARCINSKI</strong><br />
            Oskar Arkadiusz Marcinski<br />
            SIRET : 101 116 994 00019<br />
            37 Rue Lecocq, 33000 Bordeaux, France
          </div>

          <div className="space-y-12 font-sans font-light text-[#333] text-base leading-loose">
            <div>
              <h2 className="font-serif font-medium text-brand-noir text-2xl mb-5">
                <a href="#article-1" id="article-1">1. Objet</a>
              </h2>
              <p>
                Les présentes conditions générales régissent l'utilisation du site internet de MARCINSKI.
                Le site a pour objet la présentation des services de design proposés par l'entrepreneur individuel Oskar Arkadiusz Marcinski.
              </p>
            </div>

            <div>
              <h2 className="font-serif font-medium text-brand-noir text-2xl mb-5">
                <a href="#article-2" id="article-2">2. Propriété intellectuelle</a>
              </h2>
              <p>
                L'ensemble des contenus présents sur ce site (textes, visuels, éléments graphiques, logos, maquettes,
                photographies, illustrations) est protégé par le droit de la propriété intellectuelle et est la
                propriété exclusive de MARCINSKI, sauf mention contraire.
              </p>
              <p className="mt-4">
                Toute reproduction, représentation, modification, publication, adaptation ou exploitation de tout
                ou partie des contenus du site, quel que soit le moyen ou le procédé utilisé, est interdite sans
                l'autorisation écrite préalable de MARCINSKI.
              </p>
            </div>

            <div>
              <h2 className="font-serif font-medium text-brand-noir text-2xl mb-5">
                <a href="#article-3" id="article-3">3. Responsabilité</a>
              </h2>
              <p>
                MARCINSKI s'efforce de fournir des informations exactes et à jour sur ce site. Toutefois, il ne
                peut être tenu responsable des erreurs ou omissions, ni des dommages directs ou indirects pouvant
                résulter de l'utilisation des informations contenues sur ce site.
              </p>
            </div>

            <div>
              <h2 className="font-serif font-medium text-brand-noir text-2xl mb-5">
                <a href="#article-4" id="article-4">4. Liens hypertextes</a>
              </h2>
              <p>
                Ce site peut contenir des liens vers des sites tiers. MARCINSKI n'exerce aucun contrôle sur ces
                sites et décline toute responsabilité quant à leur contenu.
              </p>
            </div>

            <div>
              <h2 className="font-serif font-medium text-brand-noir text-2xl mb-5">
                <a href="#article-5" id="article-5">5. Droit applicable</a>
              </h2>
              <p>
                Les présentes conditions générales sont soumises au droit français. En cas de litige, les tribunaux
                français seront seuls compétents.
              </p>
            </div>

            <div>
              <h2 className="font-serif font-medium text-brand-noir text-2xl mb-5">
                <a href="#article-6" id="article-6">6. Contact</a>
              </h2>
              <p>
                Pour toute question relative aux présentes conditions générales, vous pouvez nous contacter via la
                page <a href="/contact" className="text-brand-or underline">Contact</a>.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
